import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import ui from './uiReducer';
import meta from './metaReducer';

const rootReducer = combineReducers({
  form,
  meta,
  ui
});

export default rootReducer;
